export default __webpack_public_path__ + "static/media/open_bet.01ab580d.mp3";